import { z } from 'zod'

export const schema = z.object({
  reviews: z.array(
    z.object({
      id: z.string(),
      title: z.string(),
      description: z.string(),
      points: z.number().int(),
      cottage: z.object({
        id: z.string(),
        name: z.string(),
        slug: z.string(),
        region: z.object({
          slug: z.string(),
          name: z.string(),
        }),
        province: z.object({
          slug: z.string(),
          name: z.string(),
        }),
        village: z.object({
          slug: z.string(),
          name: z.string(),
        }),
      }),
      traveler: z.object({
        id: z.string(),
        name: z.string(),
        media: z.object({
          url: z.string(),
        }),
      }),
      createdAt: z.string(),
    }),
  ),
  summary: z.object({
    averageReviewScore: z.number(),
    bestScore: z.number().int(),
    countScore: z.number().int(),
  }),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  destination_slug: z.string(),
  limit: z.number().int(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
